<template>
	<section>
		<Drawer :title="titleObj[business_type]" placement="right" :mask-closable="false" :value="visible" width="35%"
			@on-close="closeSelect" style="z-index:9999" class="drawer1">
			<div slot="close">
				<el-button type="text" style="margin-right:30px;">{{maxNumber>0?'提示：最多选择'+maxNumber:''}}</el-button>
				<el-button type @click="closeSelect" size="small">取消</el-button>
				<el-button type="primary" @click="toSubmit()" size="small">确定</el-button>
			</div>
			<div>
				<el-input placeholder="输入关键字过滤" prefix-icon="el-icon-search" v-model="filterText1"
					style="width:100%;margin-bottom:10px" size="small" clearable></el-input>
				<el-tree :data="treeList" :filter-node-method="filterNode1" show-checkbox node-key="value" ref="tree0"
					:props="{label:'label',children:'list'}" @check-change="checkChange"
					:default-checked-keys="defaultCheckIds"></el-tree>
			</div>
		</Drawer>
	</section>
</template>

<script>
	import { schoolUser, schoolClass, organize } from "@/api/common";
	import { Drawer } from "iview";
	import { businessName } from "@/components/form/generator/config";

	export default {
		props: {
			business_type: {
				type: String,
				default: "student", //student选择学生,classlist班级,teacher老师,department部门
			},
			visible: {
				type: Boolean,
				default: false,
			},
			maxNumber: {
				//可选择的数量，1单选，0不限制
				type: Number,
				default: 0,
			},
			defaultCheckIds: {
				//已选择id
				type: Array,
				defautl: [],
			},
		},
		data() {
			return {
				treeList: [],
				filterText1: "",
				titleObj: businessName,
			};
		},
		watch: {
			visible(newV, oldV) {
				if (newV) {
					this.getListBy();
				}
			},
			filterText1(val) {
				this.$refs.tree0.filter(val);
			},
		},

		components: { Drawer },

		methods: {
			getListBy() {
				this.treeList = [];
				let promise;
				switch (this.business_type) {
					case "department":
						promise = organize.getTree(); //获取部门
						break;
					case "classlist":
						promise = schoolClass.findByRole(); //获取班级
						break;
					case "teacher":
						promise = schoolUser.findUserByGroup({ type: 1 }); //获取老师
						break;
					default:
						promise = schoolUser.findUserByGroup({ type: 2 }); //获取学生
						break;
				}
				const disabled = this.defaultCheckIds && this.defaultCheckIds.length >= this.maxNumber && this.maxNumber > 0 ? true : false
				promise.then((res) => {
					if (res.data) {
						let items = res.data;
						let result = [];
						switch (this.business_type) {
							case "department":
								function traverse(child) {
									if (child.children != undefined) {
										traverse(children);
									}
									return child.map((z) => {
										return {
											is_group: false,
											value: z.id,
											label: z.name,
											disabled: disabled ? (this.defaultCheckIds.includes(z.id) ? false : true) : disabled,
											list:
												z.children && z.children.length
													? traverse(z.children)
													: [],
										};
									});
								}
								result = traverse(items);
								break;
							case "classlist":
								result = items.map((r, i) => {
									return {
										is_group: false,
										value: r.id,
										label: r.full_name,
										disabled: disabled ? (this.defaultCheckIds.includes(r.id) ? false : true) : disabled,
										list: [],
									};
								});
								break;
							default:
								result = items.map((r, i) => {

									return {
										is_group: true, //判断是否分组,提交时需要过滤掉
										value: r.class_id
											? r.class_id
											: i + "_" + r.class_id,
										label: r.name,
										list:
											r.list && r.list.length
												? r.list.map((z) => {
													return {
														is_group: false,
														group_id: r.class_id,
														value: z.user_id,
														label: z.name,
														id: r.user_id,
														disabled: disabled ? (this.defaultCheckIds.includes(z.user_id) ? false : true) : disabled
													};
												})
												: [],
									};
								});
								break;
						}

						this.treeList = result;
					}
				});

			},
			filterNode1(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			checkChange(data, checked) {
				if (this.maxNumber == 0 || !this.maxNumber) return;
				let nodes = this.$refs.tree0
					.getCheckedNodes()
					.filter((n) => !n.is_group)
				this.setTreeDisabled(null, []);
				if (nodes.length >= this.maxNumber) {
					nodes = nodes.slice(0, this.maxNumber)
					this.setTreeDisabled(true, nodes);
				}
			},

			setTreeDisabled(disabled, nodes) {
				this.$refs.tree0.children.forEach((n) => {
					if (!nodes.some(v => v.value == n.value))
						this.$set(n, "disabled", disabled);
					if (n.list && n.list.length > 0) {
						n.list.forEach((o) => {
							if (!nodes.some(v => v.value == o.value))
								this.$set(o, "disabled", disabled);
						});
					}
				});
			},

			// 关闭
			closeSelect() {
				this.$emit("closeSelect");
			},
			// 确定接收人
			toSubmit() {
				// 获取选中节点数据
				let listS_ret = [];
				this.treeList.forEach((r, i) => {
					listS_ret = this.$refs.tree0.getCheckedNodes();
				});
				listS_ret = listS_ret.filter((e) => !e.is_group);
				// 去重复
				let check_list = [];
				listS_ret.forEach((r) => {
					if (check_list.findIndex((e) => e.value == r.value) == -1) {
						check_list.push(r);
					}
				});

				if (check_list.length == 0) {
					this.$message;
					return;
				}
				if (this.maxNumber > 0 && check_list.length > this.maxNumber) {
					check_list = check_list.slice(0, this.maxNumber);
				}
				// console.log("check_list", check_list);
				this.$emit("submit", check_list);
			},
		},
		mounted() {

		},
	};
</script>

<style scoped lang="scss">
	.drawer1 /deep/ .ivu-drawer-wrap {
		z-index: 9999;
	}
	.drawer1 /deep/ .ivu-drawer-mask {
		z-index: 9998;
	}
	.drawer1 /deep/ .ivu-drawer-body {
		padding: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/form/index/selectBusiness.vue